// src/utils/logger.js
// Environment-aware logger that only logs in development
// In production builds (Netlify), logs are silenced to keep console clean for end users

const isDev = import.meta.env.DEV; // true in `npm run dev`, false in production builds

export const logger = {
  log: (...args) => isDev && console.log(...args),
  warn: (...args) => isDev && console.warn(...args),
  error: (...args) => console.error(...args), // Always log errors
  debug: (...args) => isDev && console.log('[DEBUG]', ...args),
  info: (...args) => isDev && console.log('[INFO]', ...args),
};

export default logger;
